import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./contexts/AuthContext";
import { FeatureAccessProvider } from "./contexts/FeatureAccessContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ToastContainer } from "./components/ui/Toast";
import { AppRoutes } from "./routes/AppRoutes";
import { GoogleAnalytics } from "./components/GoogleAnalytics";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <GoogleAnalytics />
        <ThemeProvider>
          <LanguageProvider>
            <AuthProvider>
              <FeatureAccessProvider>
                <AppRoutes />
                <ToastContainer />
              </FeatureAccessProvider>
            </AuthProvider>
          </LanguageProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
